import { DTOObjectMeta } from "../../aux/meta";
import z from "zod";
export const DTOFigmaComponentGroup = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    persistentId: z.string(),
    isRoot: z.boolean(),
    brandId: z.string(),
    meta: DTOObjectMeta,
    childrenIds: z.string().array(),
});
export const DTOFigmaComponentGroupListResponse = z.object({
    groups: DTOFigmaComponentGroup.array(),
});
